import { selector } from 'recoil';
import useCatalogAPI from '../../components/api/CatalogAPI';

const ItemConvertCatalogSelector = selector({
  key: 'itemConvertCatalogSelector',
  get: async () => {
    const api = useCatalogAPI();
    const result = await api.fetchItemConvertCatalog();
    return result;
  },
});

export default ItemConvertCatalogSelector;
